import {
  INumberFormatter,
  NUMBER_FORMATTER_TOKEN,
  SCENE_FACTORY_TOKEN,
  SceneFactory,
} from '@cgs/common';
import { RESOURCES_COMPONENT_TOKEN, ResourcesComponent } from '@cgs/machines';
import { TRIFECTA_LAUNCH_PARAMS_TOKEN, TrifectaLaunchParamsDto } from '@cgs/provider-trifecta';
import { Container, FunctionAction, IntervalAction, SceneObject, TextSceneObject } from '@cgs/wge';

export const COLLAPSE_WIN_COMPONENT_TOKEN = Symbol('COLLAPSE_WIN_COMPONENT_TOKEN');

export class CollapseWinComponent {
  private readonly collapseWinScene: SceneObject;
  private readonly collapseWinTextNode: TextSceneObject;
  private readonly currencyDecimals: number;
  private readonly currency: string;
  private readonly numberFormatter: INumberFormatter;

  constructor(container: Container) {
    const root = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN).slot;

    const sceneFactory = container.resolve<SceneFactory>(SCENE_FACTORY_TOKEN);
    this.numberFormatter = container.resolve<INumberFormatter>(NUMBER_FORMATTER_TOKEN);

    const collapseWinScene = sceneFactory.build('additional/feature_text')!;
    collapseWinScene.z = 1;

    this.collapseWinScene = collapseWinScene;
    this.collapseWinTextNode = collapseWinScene.findById<TextSceneObject>('icon_text')!;
    this.collapseWinTextNode.format = '';

    collapseWinScene.initialize();

    root.addChild(collapseWinScene);

    const launchParams = container.resolve<TrifectaLaunchParamsDto>(TRIFECTA_LAUNCH_PARAMS_TOKEN);

    this.currencyDecimals = launchParams.currencyDecimals;
    this.currency = launchParams.currencyId;
  }

  public showCollapseWinAction(win: number): IntervalAction {
    return new FunctionAction(() => {
      if (win === 0) {
        return;
      }

      this.collapseWinTextNode.text = `${this.currency} ${this.numberFormatter.format(win, this.currencyDecimals)}`;
      this.collapseWinScene.stateMachine?.switchToState('default');
      this.collapseWinScene.stateMachine?.switchToState('anim');
    });
  }
}
